import React, { useState, useMemo, useEffect } from "react";
import { Container, Table, Button, Badge, Modal, Form, Row, Col, Stack, ProgressBar, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAuth } from "../AuthContext";
import "../App.css";
import { esalonariApi } from "../api/index";    
import { XCircleFill, FileEarmarkExcel } from "react-bootstrap-icons";
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

const TabelContracte = ({
  titlu,
  date,
  laEditare,
  toatePartizile,
  setContracte,
  tema,
}) => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [contractCurent, setContractCurent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [partidaSelectata, setPartidaSelectata] = useState(null);
  const [partidaActiva, setPartidaActiva] = useState(null);
  const [dateEsalonare, setDateEsalonare] = useState([]);
  const [showEsalonare, setShowEsalonare] = useState(false);
  const [showRealizari, setShowRealizari] = useState(false);
  const [dateRealizari, setDateRealizari] = useState([]);
  const [cautareTabel, setCautareTabel] = useState("");
  const [paginaCurenta, setPaginaCurenta] = useState(1);
  const reperePePagina = 10;
  useEffect(() => {
    setPaginaCurenta(1);
  }, [cautareTabel]);
  const totalRealizatAnterior = dateRealizari.reduce(
    (acc, r) => acc + (parseFloat(r.volumRealizat) || 0),
    0,
  );

  const totalIntroducereNoua = dateRealizari.reduce((acc, r) => {
    const vol = parseFloat(r.inputNou) || 0;
    const pierd = parseFloat(r.inputPierderi) || 0;
    return acc + vol + pierd;
  }, 0);

  const handleDelete = async (contract) => {
    const result = await Swal.fire({
      title: "Ești sigur?",
      text: `Vrei să ștergi contractul nr. ${contract.nrCtr}? Partizile asociate vor deveni din nou disponibile.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Da, șterge-l!",
      cancelButtonText: "Anulează",
      reverseButtons: true,
    });

    // 2. Dacă a confirmat, trimitem cererea la SERVER
    if (result.isConfirmed) {
      try {
        const response = await fetch(`/api/contracte/${contract.id}`, {
          method: "DELETE",
        });

        if (!response.ok) {
          throw new Error("Eroare la ștergerea de pe server.");
        }
        if (typeof setContracte === "function") {
          setContracte((prev) => prev.filter((c) => c.id !== contract.id));
        }

        // 3. Notificare succes (fără buton)
        Swal.fire({
          title: "Șters!",
          text: "Contractul a fost eliminat.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        Swal.fire("Eroare!", error.message, "error");
      }
    }
  };

  const handleStergeReceptie = async (esalonareId, receptie) => {
    const confirmare = await Swal.fire({
      title: "Ștergi recepția?",
      text: `Vrei să elimini ${receptie.nrReceptie}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Da, șterge-o!",
      cancelButtonText: "Nu",
    });

    if (confirmare.isConfirmed) {
      try {
        // 1. Ștergem de pe server
        await esalonariApi.deleteReceptie(esalonareId, receptie);

        // 2. ACTUALIZĂM ECRANUL (fără refresh la pagină)
        setDateRealizari((prev) =>
          prev.map((rand) => {
            if (rand.id === esalonareId) {
              return {
                ...rand,
                istoricReceptii: rand.istoricReceptii.filter(
                  (r) => r.dataRaportare !== receptie.dataRaportare,
                ),
                volumRealizat: (rand.volumRealizat || 0) - receptie.volum,
              };
            }
            return rand;
          }),
        );

        Swal.fire("Șters!", "Baza de date a fost actualizată.", "success");
      } catch (err) {
        Swal.fire(
          "Eroare",
          "Serverul nu a putut șterge: " + err.message,
          "error",
        );
      }
    }
  };

  const inchideModal = () => {
    setShowModal(false);

    setPartidaSelectata(null);
  };

  const salveazaRealizarile = async () => {
    if (realizareExcesiva) return;

    try {
      await esalonariApi.saveRealizari({
        dateEsalonare: dateRealizari,
        partidaId: partidaActiva.id,
      });

      Swal.fire({
        title: "Succes",
        text: "Recepțiile au fost înregistrate!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      setShowRealizari(false);

      // REÎNCĂRCARE DATE
      const dateNoi = await esalonariApi.get(partidaActiva.id);
      const datePregatite = dateNoi.map((rand) => ({
        ...rand, // Păstrează tot ce vine de la server (inclusiv volumul și volumPierderi din istoricul salvat)

        // Resetează doar câmpurile de input (ca să se golească formularul vizual)
        inputNou: 0,
        inputPierderi: 0,
        nrReceptieNou: "",
      }));
      setDateRealizari(datePregatite);
    } catch (err) {
      console.error("Eroare la salvare:", err);
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const handleStergeEsalonare = async (id) => {
    if (!id) {
      return;
    }

    try {
      const result = await Swal.fire({
        title: "Ești sigur?",
        text: "Vei șterge definitiv această lună din eșalonare!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Da, șterge-o!",
      });

      if (result.isConfirmed) {
        await esalonariApi.delete(id);
        const dateNoi = await esalonariApi.get(partidaActiva.id);
        setDateEsalonare(dateNoi);

        Swal.fire("Șters!", "Eșalonarea a fost eliminată.", "success");
      }
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const schimbaStareReprimit = async (esalonareId, stare) => {
    try {
      await esalonariApi.updateStare(esalonareId, stare );
      alert("Partida a fost marcată ca Reprimită!");
      setShowRealizari(false);
    } catch (err) {
      console.error("Eroare la schimbarea stării:", err);
    }
  };

  // --- CALCULE PENTRU MODALUL DE EȘALONARE (PROGRAMARE) ---
  const totalEsalonat = dateEsalonare.reduce(
    (acc, r) => acc + parseFloat(r.volum || 0),
    0,
  );
  const esteDepasit = totalEsalonat > (partidaActiva?.volBrut || 0);
  const restDeEsalonat = (partidaActiva?.volBrut || 0) - totalEsalonat;

  // --- CALCULE PENTRU MODALUL DE REALIZĂRI (EXECUȚIE) ---
 const totalRealizatEfectiv = dateRealizari.reduce((acc, rand) => {
   const istoric = rand.istoricReceptii || [];


   const sumIstoricV = istoric.reduce(
     (s, h) => s + (parseFloat(h.volum) || 0),
     0,
   );
   const sumIstoricP = istoric.reduce(
     (s, h) => s + (parseFloat(h.volumPierderi) || 0),
     0,
   );

   const inputV = parseFloat(rand.inputNou || 0);
   const inputP = parseFloat(rand.inputPierderi || 0);

 
   return acc + sumIstoricV + sumIstoricP + inputV + inputP;
 }, 0);

  const realizareExcesiva =
    totalRealizatEfectiv > (partidaActiva?.volBrut || 0);

  // Calcul Progres (Bara de Progres)
  const procentTotalRealizat =
    partidaActiva?.volBrut > 0
      ? (totalRealizatEfectiv / partidaActiva.volBrut) * 100
      : 0;

  const partiziDisponibileEdit = toatePartizile.filter(
    (p) =>
      p.stare === "disponibil" &&
      p.ocol === contractCurent?.ocol &&
      !contractCurent?.partiziAferente?.includes(p.id),
  );

  // Calculăm volumul și valoarea în timp real pentru contractul editat

  const volumEdit =
    contractCurent?.partiziAferente?.reduce((acc, id) => {
      const p = toatePartizile.find((part) => part.id === id);

      return acc + (p ? parseFloat(p.volBrut || 0) : 0);
    }, 0) || 0;

  const valoareEdit =
    contractCurent?.partiziAferente?.reduce((acc, id) => {
      const p = toatePartizile.find((part) => part.id === id);

      return acc + (p ? parseFloat(p.valTotal || 0) : 0);
    }, 0) || 0;

  // --- LOGICĂ FIREBASE ---

  const deschideEsalonare = async (idPartida) => {
    const p = toatePartizile.find((part) => part.id === idPartida);
    setPartidaActiva(p);
    try {
      const dateExistente = await esalonariApi.get(idPartida);
      const formatate = dateExistente.map((d) => ({
        id: d.id,
        luna: d.luna,
        volum: d.volum,
        suma: d.suma,
      }));

      setDateEsalonare(formatate.length > 0 ? formatate : []);
      setShowEsalonare(true);
    } catch (err) {
      alert("Eroare la încărcare eșalonare.");
    }
  };

  const deschideRealizari = async (idPartida) => {
    const p = toatePartizile.find((part) => part.id === idPartida);
    setPartidaActiva(p);
    try {
      const dateE = await esalonariApi.get(idPartida);
      dateE.sort((a, b) => a.luna.localeCompare(b.luna));

      const datePregatite = dateE.map((rand) => ({
        ...rand,
        inputNou: 0,
        inputPierderi: 0,
        nrReceptieNou: "",

      istoricReceptii: rand.istoricReceptii || [],
      }));

      setDateRealizari(datePregatite);
      setShowRealizari(true);
    } catch (err) {
      console.error(err);
       alert("Eroare la încărcare realizări.");
    }
  };

  const salveazaEsalonarea = async () => {
    const luniSelectate = dateEsalonare.map((d) => d.luna);
    const areDuplicate = luniSelectate.some(
      (luna, index) => luniSelectate.indexOf(luna) !== index,
    );

    if (areDuplicate) {
      return Swal.fire(
        "Atenție",
        "Ai selectat aceeași lună de mai multe ori!",
        "warning",
      );
    }

    try {
      const dateDeTrimis = {
        dateEsalonare: dateEsalonare.map((d) => ({
          id: d.id || null,
          luna: d.luna,
          volum: parseFloat(d.volum) || 0,
          suma: parseFloat(d.suma) || 0,
        })),
        partidaId: partidaActiva.id,
      };

      await esalonariApi.save(dateDeTrimis);

      Swal.fire("Succes", "Eșalonarea a fost salvată!", "success");

      const dateNoi = await esalonariApi.get(partidaActiva.id);

      const formatate = dateNoi.map((d) => ({
        id: d.id,
        luna: d.luna,
        volum: d.volum,
        suma: d.suma,
      }));

      setDateEsalonare(formatate);
    } catch (err) {
      console.error("Eroare detaliată:", err);
      Swal.fire("Eroare", "Eroare la salvarea eșalonării!", "error");
    }
  };

  const adaugaLuna = () => {
    let nouaLuna = "";

    if (dateEsalonare.length > 0) {
      const ultimeleLuni = dateEsalonare
        .map((d) => d.luna)
        .filter((l) => l)
        .sort();

      const ultima = ultimeleLuni[ultimeleLuni.length - 1];

      if (ultima) {
        const [an, luna] = ultima.split("-").map(Number);
        const data = new Date(an, luna, 1);
        const anNou = data.getFullYear();
        const lunaNoua = String(data.getMonth() + 1).padStart(2, "0");
        nouaLuna = `${anNou}-${lunaNoua}`;
      }
    } else {
      const acum = new Date();
      nouaLuna = `${acum.getFullYear()}-${String(acum.getMonth() + 1).padStart(2, "0")}`;
    }

    const dejaExista = dateEsalonare.some((d) => d.luna === nouaLuna);

    setDateEsalonare([
      ...dateEsalonare,
      {
        id: null,
        luna: dejaExista ? "" : nouaLuna,
        volum: 0,
        suma: 0,
      },
    ]);
  };

  // --- LOGICĂ EDITARE CONTRACT ---
  const handleShow = (contract) => {
    setContractCurent({ ...contract });
    setShow(true);
  };
  const handleClose = () => setShow(false);

  const tratezEditare = async (e) => {
    e.preventDefault();
    const contractOriginal = date.find((c) => c.id === contractCurent.id);
    const partiziVechiIds = contractOriginal
      ? contractOriginal.partiziAferente || []
      : [];

    const volumNou = contractCurent.partiziAferente.reduce((acc, id) => {
      const p = toatePartizile.find((part) => part.id === id);
      return acc + (p ? parseFloat(p.volBrut || 0) : 0);
    }, 0);

    const valoareNoua = contractCurent.partiziAferente.reduce((acc, id) => {
      const p = toatePartizile.find((part) => part.id === id);
      return acc + (p ? parseFloat(p.valTotal || 0) : 0);
    }, 0);

    await laEditare(
      contractCurent.id,
      { ...contractCurent, volum: volumNou, valoare: valoareNoua },
      partiziVechiIds,
    );
    handleClose();
  };

  const formateazaData = (ds) => {
    if (!ds) return "-";
    if (ds.seconds)
      return new Date(ds.seconds * 1000).toLocaleDateString("ro-RO");
    return new Date(ds).toLocaleDateString("ro-RO");
  };

  const datePermise = date.filter((item) => {
    if (user?.rol === "administrator") return true;
    return (
      item.ocol?.toString().trim().toLowerCase() ===
      user?.ocol?.toString().trim().toLowerCase()
    );
  });

  // 1. MAI ÎNTÂI FILTRĂM DATELE (Calculăm dateAfisateInTabel)
  const dateAfisateInTabel = useMemo(() => {
    if (!cautareTabel) return datePermise;

    const term = cautareTabel.toLowerCase();
    return datePermise.filter(
      (item) =>
        item.nrCtr?.toString().toLowerCase().includes(term) ||
        item.partener?.toLowerCase().includes(term) ||
        item.ocol?.toLowerCase().includes(term),
    );
  }, [datePermise, cautareTabel]);

  // 2. Apoi PAGINĂM datele deja filtrate
  const totalPagini = Math.ceil(dateAfisateInTabel.length / reperePePagina);

  const datePaginate = useMemo(() => {
    const indexInceput = (paginaCurenta - 1) * reperePePagina;
    const indexSfarsit = indexInceput + reperePePagina;
    return dateAfisateInTabel.slice(indexInceput, indexSfarsit);
  }, [dateAfisateInTabel, paginaCurenta]);

  // --- LOGICĂ DE EXPORT ÎN EXCEL ---
  const exportaExcel = () => {
    const dateExport = dateAfisateInTabel.map((item) => ({
      Ocol: item.ocol,
      "Nr. contract": item.nrCtr,
      Partizi: item.partiziAferente
        ?.map((id) => {
          const p = toatePartizile.find((part) => part.id === id);
          return p ? p.fond : "Info";
        })
        .join(", "),
      "Volum (mc)": item.volum?.toFixed(2) || 0,
      "Valoare (RON)": parseFloat(item.valoare || 0).toLocaleString("ro-RO"),
      Data: formateazaData(item.dataCreare),
      Partener: item.partener,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dateExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contracte");
    XLSX.writeFile(
      workbook,
      "contracte_export_" + new Date().toISOString().slice(0, 10) + ".xlsx",
    );
  };

  return (
    <Container fluid className="mt-4">
      <div className="d-flex align-items-center border-bottom mb-3 pb-2">
        <h3 className="text-success fw-bold mb-0">{titlu}</h3>

        <Button
          variant="outline-success"
          className="ms-auto d-flex align-items-center"
          onClick={exportaExcel}
        >
          <FileEarmarkExcel size={20} className="me-2" />
          Exportă în Excel
        </Button>
      </div>
      {/* BARA DE CĂUTARE - (deasupra tabelului) */}
      <Row className="mb-3">
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Caută contract, ocol sau partener..."
            value={cautareTabel}
            onChange={(e) => setCautareTabel(e.target.value)}
            className="shadow-sm"
          />
        </Col>
      </Row>
      {totalPagini > 1 && (
        <div className="w-100 mt-3">
          <Pagination
            className="shadow-sm w-100 d-flex text-center"
            style={{ display: "flex", width: "100%" }}
          >
            {[...Array(totalPagini)].map((_, idx) => {
              const numarPagina = idx + 1;
              const esteActiv = numarPagina === paginaCurenta;

              const temaSalvata = localStorage.getItem("tema");
              const esteApasatDark = temaSalvata === "dark";

              const stilNavigare = esteApasatDark
                ? {
                    backgroundColor: "#212529",
                    borderColor: "#495057",
                    color: "#fff",
                  }
                : {
                    backgroundColor: "#fff",
                    borderColor: "#dee2e6",
                    color: "#198754",
                  };

              return (
                <React.Fragment key={numarPagina}>
                  {/* Butoanele de la începutul listei */}
                  {idx === 0 && (
                    <>
                      <Pagination.First
                        onClick={() => setPaginaCurenta(1)}
                        disabled={paginaCurenta === 1}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                      <Pagination.Prev
                        onClick={() =>
                          setPaginaCurenta((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={paginaCurenta === 1}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                    </>
                  )}

                  {/* Numerele paginilor din mijloc */}
                  <Pagination.Item
                    active={esteActiv}
                    onClick={() => setPaginaCurenta(numarPagina)}
                    style={{ flex: 1 }}
                    linkStyle={
                      esteActiv
                        ? {
                            backgroundColor: "#198754",
                            borderColor: "#198754",
                            color: "#fff",
                          }
                        : esteApasatDark
                          ? {
                              backgroundColor: "#212529",
                              borderColor: "#495057",
                              color: "#fff",
                            }
                          : {
                              backgroundColor: "#fff",
                              borderColor: "#dee2e6",
                              color: "#198754",
                            }
                    }
                  >
                    {numarPagina}
                  </Pagination.Item>

                  {/* Butoanele de la sfârșitul listei */}
                  {idx === totalPagini - 1 && (
                    <>
                      <Pagination.Next
                        onClick={() =>
                          setPaginaCurenta((prev) =>
                            Math.min(prev + 1, totalPagini),
                          )
                        }
                        disabled={paginaCurenta === totalPagini}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                      <Pagination.Last
                        onClick={() => setPaginaCurenta(totalPagini)}
                        disabled={paginaCurenta === totalPagini}
                        style={{ flex: 1 }}
                        linkStyle={stilNavigare}
                      />
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </Pagination>
        </div>
      )}
      <Table striped bordered hover responsive className="shadow-sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Nr. contract</th>
            <th>Ocol</th>
            <th>Volum (mc)</th>
            <th>Valoare (RON)</th>
            <th>Data</th>
            <th>Partener</th>
            <th style={{ width: "10%" }}>Partizi</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {datePaginate.map((item, index) => {
            const indexReal = (paginaCurenta - 1) * reperePePagina + index + 1;

            return (
              <tr key={item.id || index}>
                <td>{indexReal}</td>
                <td>{item.nrCtr || "-"}</td>
                <td>{item.ocol}</td>
                <td>{item.volum?.toFixed(2) || 0}</td>
                <td>{parseFloat(item.valoare || 0).toLocaleString("ro-RO")}</td>
                <td>{formateazaData(item.dataCreare)}</td>
                <td>
                  <strong>{item.partener}</strong>
                </td>
                <td>
                  {item.partiziAferente?.map((idPartida) => {
                    const p = toatePartizile.find(
                      (part) => part.id === idPartida,
                    );
                    const esteReprimita = p?.stare === "reprimit";
                    return (
                      <div
                        key={idPartida}
                        className="d-flex align-items-center mb-1"
                      >
                        <Badge
                          bg="info"
                          onClick={() => {
                            setPartidaSelectata(p);
                            setShowModal(true);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {p ? p.fond : "Info"}
                        </Badge>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={() => deschideEsalonare(idPartida)}
                        >
                          <Badge bg="warning" className="text-dark">
                            Esalonare
                          </Badge>
                        </Button>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={() => deschideRealizari(idPartida)}
                        >
                          <Badge bg="success">Exploatat</Badge>
                        </Button>
                        {esteReprimita && (
                          <Badge
                            bg="danger"
                            className="ms-1"
                            style={{ cursor: "default" }}
                          >
                            Reprimit
                          </Badge>
                        )}
                      </div>
                    );
                  })}
                </td>
                <td className="text-center">
                  {user?.rol === "administrator" ? (
                    <>
                      <Button
                        variant="outline-warning"
                        size="sm"
                        className="me-2"
                        onClick={() => handleShow(item)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(item)}
                      >
                        Șterge
                      </Button>
                    </>
                  ) : (
                    <Badge bg="secondary">Blocat</Badge>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {/* MODAL EȘALONARE (CU VALIDĂRI) */}
      <Modal
        show={showEsalonare}
        onHide={() => setShowEsalonare(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Eșalonare partida: {partidaActiva?.fond}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered size="sm" className="text-center" responsive>
            <thead>
              <tr>
                <th>Lună</th>
                <th>Volum (mc)</th>
                <th>Suma (RON)</th>
                <th>Ștergere</th>
              </tr>
            </thead>
            <tbody>
              {dateEsalonare.map((rand, index) => {
                const esteLunaDuplicata = dateEsalonare.some(
                  (item, idx) =>
                    item.luna === rand.luna &&
                    idx !== index &&
                    rand.luna !== "",
                );

                return (
                  <tr key={rand.id || index}>
                    <td>
                      <Form.Control
                        type="month"
                        value={rand.luna}
                        isInvalid={esteLunaDuplicata}
                        onChange={(e) => {
                          const noi = [...dateEsalonare];
                          noi[index].luna = e.target.value;
                          setDateEsalonare(noi);
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Lună duplicată!
                      </Form.Control.Feedback>
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={rand.volum === 0 ? "" : rand.volum}
                        placeholder=""
                        isInvalid={esteDepasit}
                        onChange={(e) => {
                          const vStr = e.target.value;
                          const noi = [...dateEsalonare];
                          const vNum = vStr === "" ? 0 : parseFloat(vStr);

                          noi[index].volum = vNum;
                          noi[index].suma =
                            vNum * (partidaActiva?.tarifBrut || 0);
                          setDateEsalonare(noi);
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={rand.suma.toFixed(2)}
                        readOnly
                        className="bg-light"
                      />
                    </td>
                    <td>
                      <Button
                        variant="link"
                        className="text-danger p-0 ms-2"
                        onClick={() => {
                          if (rand.id) {
                            handleStergeEsalonare(rand.id);
                          } else {
                            const noi = dateEsalonare.filter(
                              (_, i) => i !== index,
                            );
                            setDateEsalonare(noi);
                          }
                        }}
                      >
                        <XCircleFill size={18} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <Button variant="outline-primary" onClick={adaugaLuna}>
            + Adaugă Lună
          </Button>

          <div
            className={`mt-3 p-3 rounded border ${esteDepasit ? "bg-danger text-white border-danger" : "bg-light border-success"}`}
          >
            <Row>
              <Col>
                <strong>Total Partidă:</strong>{" "}
                {partidaActiva?.volBrut.toFixed(2)} mc
              </Col>
              <Col>
                <strong>Eșalonat:</strong> {totalEsalonat.toFixed(2)} mc
              </Col>
              <Col className="text-end">
                {esteDepasit ? (
                  <strong>
                    ⚠️ Depășire:{" "}
                    {(totalEsalonat - partidaActiva.volBrut).toFixed(2)} mc
                  </strong>
                ) : (
                  <strong>Rămas: {restDeEsalonat.toFixed(2)} mc</strong>
                )}
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <OverlayTrigger
            placement="top"
            overlay={
              partidaActiva?.stare === "reprimit" ? (
                <Tooltip id="tooltip-disabled">
                  Această partidă este deja reprimita și nu mai poate fi
                  modificată.
                </Tooltip>
              ) : (
                <></>
              )
            }
          >
            <span className="d-inline-block">
              <Button
                variant="primary"
                onClick={salveazaEsalonarea}
                disabled={
                  esteDepasit ||
                  totalEsalonat === 0 ||
                  partidaActiva?.stare === "reprimit" ||
                  dateEsalonare.some((rand, idx) =>
                    dateEsalonare.some(
                      (item, i) => item.luna === rand.luna && i !== idx,
                    ),
                  )
                }
              >
                Salvează eșalonările
              </Button>
            </span>
          </OverlayTrigger>
        </Modal.Footer>
      </Modal>
      {/* MODAL REALIZĂRI (INPUT RECEPTII NOI + ISTORIC COMPLET) */}
      <Modal
        show={showRealizari}
        onHide={() => setShowRealizari(false)}
        size="lg"
        centered
      >
        <Modal.Header
          closeButton
          className={
            realizareExcesiva ? "bg-danger text-white" : "bg-success text-white"
          }
        >
          <Modal.Title>
            Jurnal Recepții: {partidaActiva?.fond}
            {realizareExcesiva && (
              <small className="ms-3 fw-light">⚠️ VOLUM DEPĂȘIT!</small>
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* TABEL INPUT */}
          <h6 className="fw-bold mb-3">Introducere recepție nouă</h6>
          <Table striped bordered hover responsive align="middle" size="sm">
            <thead className="table-light small text-center">
              <tr>
                <th>Lună</th>
                <th>Realizat Ant.</th>
                <th>Nr. Doc</th>
                <th>Volum (mc)</th>
                <th>Pierderi (mc)</th>
              </tr>
            </thead>
            <tbody>
              {dateRealizari.map((rand, index) => (
                <tr key={rand.id || index}>
                  <td className="fw-bold">{rand.luna}</td>
                  <td className="text-muted small">
                    {(parseFloat(rand.volumRealizat) || 0).toFixed(2)}
                  </td>
                  <td>
                    <Form.Control
                      size="sm"
                      placeholder="Ex: Receptia 1"
                      value={rand.nrReceptieNou || ""}
                      onChange={(e) => {
                        const noi = [...dateRealizari];
                        noi[index].nrReceptieNou = e.target.value;
                        setDateRealizari(noi);
                      }}
                    />
                  </td>
                  <td>
                    <Form.Control
                      size="sm"
                      type="number"
                      placeholder="mc"
                      value={rand.inputNou === 0 ? "" : rand.inputNou}
                      isInvalid={realizareExcesiva}
                      onChange={(e) => {
                        const noi = [...dateRealizari];
                        noi[index].inputNou =
                          e.target.value === ""
                            ? 0
                            : parseFloat(e.target.value);
                        setDateRealizari(noi);
                      }}
                    />
                  </td>
                  <td>
                    <Form.Control
                      size="sm"
                      type="number"
                      placeholder="pierderi"
                      className="text-danger"
                      value={rand.inputPierderi === 0 ? "" : rand.inputPierderi}
                      isInvalid={realizareExcesiva}
                      onChange={(e) => {
                        const noi = [...dateRealizari];
                        noi[index].inputPierderi =
                          e.target.value === ""
                            ? 0
                            : parseFloat(e.target.value);
                        setDateRealizari(noi);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* PROGRESS BAR CU INTERDICȚIE VIZUALĂ */}
          <div className="mt-4 mb-3 p-3 bg-white border rounded shadow-sm">
            <div className="d-flex justify-content-between mb-1 fw-bold">
              <span>Progres Exploatare (Inclusiv pierderi)</span>
              <span
                className={realizareExcesiva ? "text-danger" : "text-success"}
              >
                {totalRealizatEfectiv.toFixed(1)} / {partidaActiva?.volBrut} mc
              </span>
            </div>
            <ProgressBar
              now={procentTotalRealizat > 100 ? 100 : procentTotalRealizat}
              variant={realizareExcesiva ? "danger" : "success"}
              label={`${procentTotalRealizat.toFixed(1)}%`}
              striped
              animated={realizareExcesiva}
              style={{ height: "25px" }}
            />
            {realizareExcesiva && (
              <div className="text-danger small mt-1 fw-bold text-center">
                ❌ Nu puteți salva: Volumul introdus depășește volumul brut al
                partizii!
              </div>
            )}
          </div>

          {/* ISTORIC CU COLOANĂ DE PIERDERI */}
          <div className="mt-4">
            <h6 className="fw-bold text-muted border-bottom pb-2 mb-2 small">
              ISTORIC RECEPȚII
            </h6>
            <div
              style={{ maxHeight: "150px", overflowY: "auto" }}
              className="border rounded"
            >
              <Table hover size="sm" className="mb-0 small">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>Document</th>
                    <th>Data</th>
                    <th className="text-end">Volum</th>
                    <th className="text-end">Pierderi</th>
                  </tr>
                </thead>
                <tbody>
                  {dateRealizari.map((rand) =>
                    rand.istoricReceptii?.map((hist, i) => (
                      <tr key={`${rand.id}-${i}`}>
                        <td>{hist.nrReceptie}</td>
                        <td>
                          {new Date(hist.dataRaportare).toLocaleDateString(
                            "ro-RO",
                          )}
                        </td>
                        <td className="text-end fw-bold">{hist.volum} mc</td>
                        <td className="text-end text-danger">
                          {hist.volumPierderi?.toFixed(2) || 0} mc
                        </td>
                        <td className="text-center">
                          <Button
                            variant="link"
                            size="sm"
                            className="text-danger p-0"
                            onClick={() => handleStergeReceptie(rand.id, hist)}
                          >
                            <XCircleFill />
                          </Button>
                        </td>
                      </tr>
                    )),
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {Math.abs(
            totalRealizatEfectiv - (parseFloat(partidaActiva?.volBrut) || 0),
          ) <=
            parseFloat(partidaActiva?.volBrut) * 0.05 &&
          partidaActiva?.stare !== "reprimit" ? (
            <Button
              variant="warning"
              className="me-auto"
              onClick={async () => {
                try {
                  await esalonariApi.updateStarePartida(
                    partidaActiva.id,
                    "reprimit",
                  );
                  Swal.fire(
                    "Succes",
                    "Starea partizii a fost actualizată!",
                    "success",
                  );
                  setShowRealizari(false);
                } catch (err) {
                  Swal.fire("Eroare", err.message, "error");
                }
              }}
            >
              Marchează ca Reprimit
            </Button>
          ) : (
            partidaActiva?.stare === "reprimit" && (
            
                <Badge bg="secondary" className="me-auto">
                  Reprimita
                </Badge>
             
            )
          )}

          <Button
            variant="outline-secondary"
            onClick={() => setShowRealizari(false)}
          >
            Anulează
          </Button>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-disabled">
                Partida este deja reprimita și nu mai poate fi modificată.
              </Tooltip>
            }
          >
            <span className="d-inline-block">
            <Button
              variant={realizareExcesiva ? "danger" : "success"}
              onClick={salveazaRealizarile}
              disabled={realizareExcesiva || totalIntroducereNoua === 0 || partidaActiva?.stare === "reprimit"}
            >
            {realizareExcesiva ? "Depășire Volum" : "Confirmă recepția"}
          </Button>
          </span>
          </OverlayTrigger>
        </Modal.Footer>
      </Modal>
      {/* MODAL PENTRU EDITARE */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Modifică Contract: {contractCurent?.partener}
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={tratezEditare}>
          <Modal.Body>
            {contractCurent && (
              <>
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">
                        Partener / Firmă
                      </Form.Label>

                      <Form.Control
                        type="text"
                        value={contractCurent.partener}
                        onChange={(e) =>
                          setContractCurent({
                            ...contractCurent,

                            partener: e.target.value,
                          })
                        }
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* SECȚIUNE TAG-URI PARTIZI */}

                <div className="mb-3">
                  <Form.Label className="fw-bold text-success">
                    Partizi incluse actual:
                  </Form.Label>

                  <div className="p-2 border rounded mb-2 border-success">
                    <Stack direction="horizontal" gap={2} className="flex-wrap">
                      {contractCurent.partiziAferente?.map((id) => {
                        const p = toatePartizile.find((part) => part.id === id);

                        return (
                          <Badge
                            key={id}
                            bg="success"
                            className="p-2 d-flex align-items-center"
                          >
                            {p?.fond} ({p?.volBrut} mc)
                            <XCircleFill
                              className="ms-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                const noiPartizi =
                                  contractCurent.partiziAferente.filter(
                                    (pid) => pid !== id,
                                  );

                                setContractCurent({
                                  ...contractCurent,

                                  partiziAferente: noiPartizi,
                                });
                              }}
                            />
                          </Badge>
                        );
                      })}
                    </Stack>
                  </div>

                  <Form.Label className="fw-bold text-primary">
                    Adaugă partizi disponibile ({contractCurent.ocol}):
                  </Form.Label>

                  <div className="p-2 border rounded bg-light">
                    <Stack direction="horizontal" gap={2} className="flex-wrap">
                      {partiziDisponibileEdit
                        .filter(
                          (p) =>
                            !(contractCurent.partiziAferente || []).includes(
                              p.id,
                            ),
                        )
                        .map((p) => (
                          <Button
                            key={p.id}
                            variant="outline-primary"
                            size="sm"
                            onClick={() => {
                              const noiPartizi = [
                                ...(contractCurent.partiziAferente || []),
                                p.id,
                              ];
                              setContractCurent({
                                ...contractCurent,
                                partiziAferente: noiPartizi,
                              });
                            }}
                          >
                            + {p.fond}
                          </Button>
                        ))}
                    </Stack>
                  </div>
                </div>

                {/* REZUMAT CALCULE */}

                <Row className="bg-warning bg-opacity-10 p-2 rounded mx-0">
                  <Col className="text-center border-end">
                    <small className="d-block text-muted">
                      Volum actualizat
                    </small>

                    <strong>{volumEdit.toFixed(2)} mc</strong>
                  </Col>

                  <Col className="text-center">
                    <small className="d-block text-muted">
                      Valoare actualizată
                    </small>

                    <strong>{valoareEdit.toFixed(2)} RON</strong>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Anulează
            </Button>

            <Button variant="primary" type="submit">
              Salvează Modificările
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* MODAL PENTRU DETALII PARTIDĂ */}
      <Modal show={showModal} onHide={inchideModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalii partida: {partidaSelectata?.fond}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {partidaSelectata ? (
            <Row>
              <Col md={6}>
                <p>
                  <strong>Ocol:</strong> {partidaSelectata.ocol}
                </p>
                <p>
                  <strong>UP:</strong> {partidaSelectata.up} /{" "}
                  <strong>UA:</strong> {partidaSelectata.ua}
                </p>
                <p>
                  <strong>Suprafață:</strong> {partidaSelectata.suprafata} ha
                </p>

                <p>
                  <strong>Natură produs:</strong> {partidaSelectata.natura}
                </p>
                <p>
                  <strong>Garanție:</strong> {partidaSelectata.garantie} RON
                </p>
              </Col>

              <Col md={6}>
                <p>
                  <strong>Nr. SUMAL</strong> {partidaSelectata.sumal}
                </p>
                <p>
                  <strong>Volum Brut:</strong> {partidaSelectata.volBrut} mc
                </p>

                <p>
                  <strong>Valoare Totală:</strong> {partidaSelectata.valTotal}{" "}
                  RON
                </p>

                <p>
                  <strong>Stoc: </strong>
                  {partidaSelectata.stoc}
                </p>

                <p>
                  <strong>Nr. procedură:</strong> {partidaSelectata.nrProcedura}
                </p>
              </Col>
            </Row>
          ) : (
            <p>Se încarcă datele...</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={inchideModal}>
            Închide
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};;

export default TabelContracte;